// A small bird, modelled facing +X: a rounded body, a head, a beak and two
// swept-back wings. Ported 1:1 from age-of-mcp's classic bird.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.04, 0),
      color: "#3a4a6e", position: [0, 0.03, 0], scale: [1.4, 1, 1] },
    { geometry: new THREE.IcosahedronGeometry(0.025, 0),
      color: "#2a3a5a", position: [0.055, 0.05, 0] },
    { geometry: new THREE.ConeGeometry(0.009, 0.03, 4),
      color: "#f4d35e", position: [0.085, 0.05, 0], rotation: [0, 0, -Math.PI / 2] },
    { geometry: new THREE.ConeGeometry(0.018, 0.07, 3),
      color: "#2a3a5a", position: [-0.015, 0.025, 0.04],
      rotation: [Math.PI / 2, 0, 0], scale: [1, 1, 0.3] },
    { geometry: new THREE.ConeGeometry(0.018, 0.07, 3),
      color: "#2a3a5a", position: [-0.015, 0.025, -0.04],
      rotation: [-Math.PI / 2, 0, 0], scale: [1, 1, 0.3] },
  ];
}

export const bird = defineModel({
  id: "bird",
  batchId: "standard",
  name: "Bird",
  tags: ["creature","bird","low-poly","age-of-mcp","classic"],
  summary: "Low-poly bird.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.07,
  parts: () => partsFor(),
  animations: [],
});
